import { render, staticRenderFns } from "./OpenedAccounting.vue?vue&type=template&id=0f346c3d&"
import script from "./OpenedAccounting.vue?vue&type=script&lang=js&"
export * from "./OpenedAccounting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports